import { lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";
import SuspanseLoader from "./SuspanseLoader";

const Analytics = lazy(() => import("./pages/restaurants/Analytics"));
const Dashboard = lazy(() => import("./pages/restaurants/Dashboard"));
const Demo = lazy(() => import("./pages/restaurants/Demo"));
const DynamicPricing = lazy(() => import("./pages/restaurants/DynamicPricing"));
const Invoices = lazy(() => import("./pages/restaurants/Invoices"));
const MarketAnalysis = lazy(() => import("./pages/restaurants/MarketAnalysis"));
const PaymentFailure = lazy(() => import("./pages/restaurants/PaymentFailure"));
const PaymentSuccess = lazy(() => import("./pages/restaurants/PaymentSuccess"));
const PricingReview = lazy(() => import("./pages/restaurants/PricingReview"));
const Settings = lazy(() => import("./pages/restaurants/Settings"));
const Subscription = lazy(() => import("./pages/restaurants/Subscription"));
const Support = lazy(() => import("./pages/restaurants/Support"));
const SystemPerformance = lazy(
  () => import("./pages/restaurants/SystemPerformance"),
);
const TripManagement = lazy(() => import("./pages/restaurants/TripManagement"));

export const restaurantsRoutesConfig = [
  {
    index: true,
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <DynamicPricing />
      </Suspense>
    ),
  },
  {
    path: "dashboard",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <DynamicPricing />
      </Suspense>
    ),
  },
  {
    path: "demo",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <Demo />
      </Suspense>
    ),
  },
  {
    path: "trips",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <TripManagement />
      </Suspense>
    ),
  },
  {
    path: "analytics",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <Analytics />
      </Suspense>
    ),
  },
  {
    path: "customers",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <MarketAnalysis />
      </Suspense>
    ),
  },
  {
    path: "conversion",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <PricingReview />
      </Suspense>
    ),
  },
  {
    path: "performance",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <SystemPerformance />
      </Suspense>
    ),
  },
  {
    path: "settings",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <Settings />
      </Suspense>
    ),
  },
  {
    path: "support",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <Support />
      </Suspense>
    ),
  },
  {
    path: "subscription",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <Subscription />
      </Suspense>
    ),
  },
  {
    path: "subscription-enterprise",
    element: <Navigate to="/subscription" replace />,
  },
  {
    path: "invoices",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <Invoices />
      </Suspense>
    ),
  },
  {
    path: "reporting",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <Dashboard />
      </Suspense>
    ),
  },
  {
    path: "payment/success",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <PaymentSuccess />
      </Suspense>
    ),
  },
  {
    path: "payment/failure",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <PaymentFailure />
      </Suspense>
    ),
  },
];